export const initialState = {
    detail: {
        answer_a: "",
        answer_b: "",
        description: "",
        created_at: 0,
        creator_id: "",
        id: "",
        image: "",
        result: {},
        question: "",
        url: "",
        whichChecked: ""
    },
    post: {
        question: "",
        answer_a: "",
        answer_b: "",
        description: "",
        url: "",
        image: "",
    },
    questions: {
        list: [],
        lastVisible: 99991231235959,
        hasMoreLoaded: true
    },
    user: {
        birthday: "",
        block_users: {},
        gender: "",
        nick_name: "",
        isLoggedIn: false,
        isAgreed: false,
        prefecture: "",
        userId: "",
    },
    users: {},
};
